<template>
  <div id="div_login" style="background-color: lightgray;">
    <v-card class="mx-auto" width="334">
      <v-toolbar color="dark darken-2" dark >
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-form v-model="valid" ref="form" style="margin: 10px; margin-top: 30px; margin-botton: 30px">
        <v-text-field color="dark" v-model="loginInput.email" label="Usuario" :rules="usuarioRules" required prepend-icon="person"></v-text-field>
        <v-text-field color="dark" v-model="loginInput.senha" label="Senha" type="password" :rules="senhaRules" required prepend-icon="lock"></v-text-field>
        <v-card-actions class="btns">
          <v-btn color="dark darken-2" dark @click="login">
            Entrar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
//import { USUARIO_LOGADO, TOKEN } from "@/utils/constants.js";
import UsuarioService from '../services/usuarioService';
import LoginInput from '../classes/loginInput'
export default {
  data: () => ({
    valid: false,
    loading: true,
    loginInput: new LoginInput(),
    usuarioRules: [v => !!v || "Informe o nome de usuário"],
    senhaRules: [v => !!v || "Informe a senha"]
  }),
  methods: {
    async login() {
      if (!this.valid) {
        this.$refs.form.validate();
        return;
      }

      this.loading = true;
      try{
        var result = await UsuarioService.login(this.loginInput)
        if (result.data.data.login.token) {
          this.$store.dispatch('usuario/login', result.data.data.login)
          this.$router.push("/");

          //sessionStorage.setItem(USUARIO_LOGADO, this.loginInput);
          //sessionStorage.setItem(TOKEN, result.data.data.login.token);
        }
        console.log(result)
      }catch(e){
        this.$toast.error('Erro ao logar.')
        console.log(e)
      }
      this.loading = false;
    }
  },
  watch: {
    loading(val) {
      if (!val) return;

      setTimeout(() => (this.loading = false), 3000);
    }
  }
};
</script>

<style>
#div_login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

.card {
  padding: 10px;
}

.btns {
  float: right;
}

.progres {
  width: 100%;
}

.dviLoading {
  width: 346px;
  height: 10px;
  background-color: rgb(10,10,10,0.1);
  margin: 50px;
}
</style>